<!-- 缺陷reopen -->
<template>
  <div>
    <a-card size="small" :loading="loading" style="overflow: auto">
      <template slot="title">
        <span style="margin-right: 4px">研发产出分布</span>
        <a-popover title="研发热力图" placement="topLeft">
          <template slot="content">
            <p>每个方格表示当天完成的任务点总和，如当天未完成任务，则为0</p>
            <p>非工作日且当天无完成任务则为空白展示</p>
            <p>请假且当天无完成任务为空白展示</p>
            <p>加班展示加班当天的完成任务点总和，如果当天未完成任务点，则为0<cursor /></p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div id="task-pre-heat" class="task-heat-box" :style="{ height: height, width: heatWidth }" />
    </a-card>
    <div v-if="taskList && taskList.length > 0">
      <task-list-point-modal ref="taskListModal" :task-list="taskList" />
    </div>
  </div>
</template>
<script>
import { getPreTaskHeat } from '@/api/data/quality';
import TaskListPointModal from '@/pages/data/task/components/TaskListPointModal';
export default {
  components: { TaskListPointModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    taskMap: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      heatWidth: '100px',
      height: '2000px',
      seriesIndex: 0,
      index: 0,
      taskList: [],
      data: [],
      loading: false,
      option: {
        tooltip: {
          position: 'top'
        },
        grid: {
          height: '70%',
          width: '89%',
          left: '110px',
          top: '1%'
        },
        xAxis: {
          type: 'category',
          data: [],
          splitArea: {
            show: true
          }
        },
        yAxis: {
          type: 'category',
          data: [],
          splitArea: {
            show: true
          }
        },
        visualMap: {
          min: 0,
          max: 10,
          calculable: true,
          orient: 'horizontal',
          left: 'center',
          bottom: '0%',
          inRange: {
            color: ['#d4f1c3', '#c3e9ad', '#acd595', '#9cc385', '#8fc173', '#7eb260', '#6ea64d', '#639c42', '#5d973b', '#50912a']
          }
        },
        series: [
          {
            name: '任务点',
            type: 'heatmap',
            data: [],
            label: {
              show: true
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    };
  },
  watch: {
    filterForm() {
      this.getVirtualData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  created() {
    this.getVirtualData();
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/component/title');
    require('echarts/lib/component/calendar');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/visualMap');
    require('echarts/lib/chart/heatmap');
    require('echarts/lib/component/grid');
    this.myChart = echarts.init(document.getElementById('task-pre-heat'));
    this.myChart.on('click', param => {
      this.index = param.data;
    });
    this.myChart.getZr().on('click', param => {
      const pointInPixel = [param.offsetX, param.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (this.myChart.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = this.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        // const y = param.target.__ec_inner_7.seriesIndex;
        setTimeout(() => {
          this.onDetail();
        }, 10); // 延迟 200 毫秒
      }
    });
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      setTimeout(() => {
        this.myChart.setOption(this.option);
        this.myChart.resize();
      }, 20);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    onDetail() {
      this.taskList = this.data[this.index[1]][this.index[0]];
      // this.index = index;
      setTimeout(() => {
        this.$refs.taskListModal.open();
      }, 10); // 延迟 200 毫秒
    },
    getVirtualData() {
      getPreTaskHeat(this.filterForm).then(res => {
        this.data = res.data.taskList;
        this.option.xAxis.data = res.data.time_list;
        this.option.yAxis.data = res.data.user_list;
        this.option.series[0].data = res.data.heat_value;
        this.option.grid.height = res.data.user_list.length * 38 + 'px';
        this.option.grid.width = res.data.time_list.length * 50 + 'px';
        this.height = res.data.user_list.length * 38 + 100 + 'px';
        this.heatWidth = res.data.time_list.length * 50 + 280 + 'px';
        this.drawChart();
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-table-tbody > tr > td > p {
  padding: 8px;
  border-bottom: 1px solid #e8e8e8;
  line-height: 20px;
  margin: 0 -8px;
}

/deep/ .ant-table-tbody > tr > td > p:last-child {
  margin-bottom: -12px;
  border: 0;
}

/deep/ .ant-table-tbody > tr > td > p:first-child {
  margin-top: -8px;
}
/deep/.ant-page-header {
  padding: 0;
}

/deep/.ant-tabs-bar {
  margin: 0 0 12px 0;
}

.task-heat-box {
  width: 100%;
  color: #639c42;
  // overflow-x: auto;
}
</style>
